import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  url: '/report/previousYearChannelPartnerCommitmentVsShipped'
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  previousYearChannelPartnerCommitmentVsShipped: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  previousYearChannelPartnerCommitmentVsShipped: state => state.previousYearChannelPartnerCommitmentVsShipped
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_PREVIOUS_YEAR_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED = 'REQUEST_GET_PREVIOUS_YEAR_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED'
const RECEIVE_GET_PREVIOUS_YEAR_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED = 'RECEIVE_GET_PREVIOUS_YEAR_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getPreviousYearChannelPartnerCommitmentVsShipped ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting previousYearChannelPartnerCommitmentVsShipped', { root: true })
    commit(REQUEST_GET_PREVIOUS_YEAR_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED)
    const config = merge({}, endpointConfig, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    return axios.get(endpointConfig.url, config)
      .then((response) => {
        dispatch('receivePreviousYearChannelPartnerCommitmentVsShipped', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting previousYearChannelPartnerCommitmentVsShipped', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting previousYearChannelPartnerCommitmentVsShipped', { root: true })
        return Promise.reject(error)
      })
  },
  receivePreviousYearChannelPartnerCommitmentVsShipped ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_PREVIOUS_YEAR_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED`, extract(json))
    return json.data
  },
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_PREVIOUS_YEAR_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED](state, id) {
  },
  [RECEIVE_GET_PREVIOUS_YEAR_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED](state, json) {
    state.previousYearChannelPartnerCommitmentVsShipped = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
